export default __webpack_public_path__ + "static/media/MACS-FO-Logo-w.4d2b2c00.png";